

import React, { useEffect, useState } from "react";
import { auth } from "./firebase";
import { Routes, Route, Navigate } from "react-router";
import { useAuthState } from "react-firebase-hooks/auth";
import { Toaster } from 'react-hot-toast';
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "@react-hook/media-query";
import { ForgotPassword } from "./pages/ForgotPassword";

// routes

import { Signup } from "./pages/Signup";
import { NotFound } from "./pages/NotFound";
import { Bookings } from "./pages/Bookings";
import { Support } from "./pages/Support";
import { Profile } from "./pages/Profile";
import { Login } from "./pages/login/Login";
import { Home } from "./pages/home/Home";
import SupportDetails from "./pages/SupportDetails";
import PaymentStatus from "./pages/PaymentStatus";
import Surgery from "./pages/home/SurgeryItem";


// components

import BottomNavBar from "./components/BottomNav";
import Navbar from "./components/Navbar";

function App() {
  const [user, userLoading] = useAuthState(auth);

  const location = useLocation();
  const [locationValidator, setLocationValidator] = useState(false);

  useEffect(() => {
    if (
      (location.pathname.split("/")[1] === "support" &&
        location.pathname.split("/").length === 3) ||
      location.pathname === "/login" ||
      location.pathname === "/signup" || 
      location.pathname === "/forgotPassword"
    ) {
      setLocationValidator(true);
    } else {
      setLocationValidator(false);
    }
  }, [location]);

  const isAuthenticated = (user !== null && userLoading === false);
  // const isMobile = useMediaQuery("(max-width: 528px)"); // Adjust the breakpoint as needed
  const isMobile = true

  console.log(isMobile);

  return (
    <div className="App bg-gray-200 font-nunito">
      <Toaster />
      {!locationValidator && isMobile && <Navbar />}
      {!locationValidator && isMobile && <BottomNavBar />}

      {userLoading === false && (
        <div
          style={{
            marginTop: !locationValidator && isMobile ? "100px" : "0px",
            marginBottom: !locationValidator && isMobile ? "120px" : "0px",
            height: !locationValidator && isMobile
              ? "calc(100vh - 220px)"
              : "calc(100vh - 10px)",
          }}
          className="w-screen"
        >
          <Routes>
            <Route
              path="/"
              element={
                !isMobile ? (
                  <ComingSoonPage />
                ) : isAuthenticated ? (
                  <Home />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/surgery/:id" 
              element={
                !isMobile ? (
                  <ComingSoonPage />
                ) : isAuthenticated ? (
                  <Surgery />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/paymentStatus/:sessionId"
              element={
                !isMobile ? (
                  <ComingSoonPage />
                ) : isAuthenticated ? (
                  <PaymentStatus />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/bookings"
              element={
                !isMobile ? (
                  <ComingSoonPage />
                ) : isAuthenticated ? (
                  <Bookings />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/support"
              element={
                !isMobile ? (
                  <ComingSoonPage />
                ) : isAuthenticated ? (
                  <Support />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/support/:ticketId"
              element={
                !isMobile ? (
                  <ComingSoonPage />
                ) : isAuthenticated ? (
                  <SupportDetails />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route
              path="/profile"
              element={
                !isMobile ? (
                  <ComingSoonPage />
                ) : isAuthenticated ? (
                  <Profile />
                ) : (
                  <Navigate to="/login" />
                )
              }
            />
            <Route path="/login" element={<Login />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      )}
    </div>
  );
}

const ComingSoonPage = () => (
  <div className="flex items-center justify-center h-screen bg-gray-200">
    <div className="text-center">
      <h1 className="text-4xl font-bold text-gray-800 mb-4">Coming Soon!</h1>
      <p className="text-lg text-gray-600">We're working on something amazing. Stay tuned!</p>
    </div>
  </div>
);

export default App;
